module.exports = __webpack_public_path__ + "media/images/static/top/local/photo3-47246b7faead0c81d51edfb09ce21cea.png";